if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}








// if (!customElements.get('product-modal')) {
//   customElements.define(
//     'product-modal',
//     class ProductModal extends ModalDialog {
//       constructor() {
//         super();
//      this.addEventListener('click', (e) => {
//     const content = this.querySelector('.product-media-modal__content');

//     if (content && content.contains(e.target)) {
//       e.preventDefault();
//       e.stopPropagation();
//       e.stopImmediatePropagation();
//       return false;
//     }
//   }, true);

//       }

//       hide() {

//         super.hide();
//       }

//       show(opener) {
//         super.show(opener);

//         setTimeout(() => {
//           if (
//             document.querySelector('.modalSwiper') &&
//             typeof Swiper !== 'undefined'
//           ) {
//             if (window.modalSwiper) {
//               window.modalSwiper.destroy(true, true);
//             }

//             window.modalSwiper = new Swiper('.modalSwiper', {
//               slidesPerView: 1,
//               spaceBetween: 0,
//               speed: 500,

//               navigation: {
//                 nextEl: '.swiper-button-next',
//                 prevEl: '.swiper-button-prev',
//               },

//               pagination: {
//                 el: '.swiper-pagination',
//                 clickable: true,
//               },
//             });
//           }

//           this.showActiveMedia();
//         }, 100);
//       }

//       showActiveMedia() {
//         const activeMediaId =
//           this.openedBy.getAttribute('data-media-id');

//         this.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('active');
//         });

//         const activeMedia = this.querySelector(
//           `[data-media-id="${activeMediaId}"]`
//         );

//         if (!activeMedia) return;

//         activeMedia.classList.add('active');

//         if (window.modalSwiper) {
//           const slides = Array.from(
//             this.querySelectorAll('.swiper-slide')
//           );

//           const slideIndex = slides.findIndex((slide) =>
//             slide.querySelector(
//               `[data-media-id="${activeMediaId}"]`
//             )
//           );

//           if (slideIndex >= 0) {
//             window.modalSwiper.slideTo(slideIndex, 0);
//           }
//         }

//         const activeMediaTemplate =
//           activeMedia.querySelector('template');

//         const activeMediaContent =
//           activeMediaTemplate
//             ? activeMediaTemplate.content
//             : null;

//         if (
//           activeMedia.nodeName === 'DEFERRED-MEDIA' &&
//           activeMediaContent &&
//           activeMediaContent.querySelector('.js-youtube')
//         ) {
//           activeMedia.loadContent();
//         }
//       }
//     }
//   );
// }
